import { IonCol } from "@ionic/react";
import { useCallback, useEffect, useState } from "react";
import FilterList, { isFilterActive } from "../../../FilterList/FilterList";
import { FilterState } from "../../../FilterList/types";

import { Locale } from "../../../../setup/locale";
import List from "../../../List/List";
import { pageRange } from "../../../List/Pagination/pagerange";
import { HeaderOption } from "../../../List/types";
import { useNamedRoutes } from "../../../NamedRoutes";
import { useIsMobile } from "../../../Responsive";
import { Filter } from "../types/reportTypes";
import { OtherAlarmDevicesProps } from "./types";


type PersistentFilter = Filter<{}> & FilterState;

const standardFilter = {};

const ignoreKeys: (keyof PersistentFilter)[] = ["pageSize", "isFilterOpen", "page", "pageSize", "sortCriteria", "sortOrder"];

const header: HeaderOption<Locale, any>[] = [
    {
        title: 'TD_ELEM_AUSGANG', key: 'output', both: true
    },
    {
        title: 'COM_VIRTUEMART_ORDER_PRINT_QUANTITY', key: 'quantity', both: true
    },
    {
        title: '[REACT_DEVICE_CATEGORY]', key: 'deviceCategory', both: true
    },
    {
        title: '[SID_KIND]', key: 'type', breakpoint: 1200, up: true
    },
];

const OtherAlarmDevices: React.FC<OtherAlarmDevicesProps> = ({
    system,
    filter,
    onIsOpen,
    onFilterActive
}) =>
{


    const { generate } = useNamedRoutes();
    const mobileView = useIsMobile();


    const data = [
        {
            link: generate('systems'),
            output: "",
            quantity: 5,
            deviceCategory: system.name,
            type: "",
        },

    ];


    const [list,] = useState<any[] | null>(data);


    const [currentState, setState] = useState<PersistentFilter>({});

    const [clearFilterInputs, setClearFilterInputs] = useState(false);

    const [currentRowLimit, setCurrentRowLimit] = useState<number>(pageRange[1]);


    const onPageChange = useCallback((page: PersistentFilter["page"]) => setState((prev) => ({ ...prev, page })), [setState]);
    const onSortChange = useCallback((sortCriteria: PersistentFilter["sortCriteria"], sortOrder: PersistentFilter["sortOrder"]) => setState((prev) => ({ ...prev, sortCriteria, sortOrder })), [setState]);
    const onPageSizeChange = useCallback((pageSize: PersistentFilter["pageSize"]) => setState((prev) => ({ ...prev, pageSize })), [setState]);
    const onReloadChange = useCallback(() => setState((prev) => ({ ...prev })), [setState]);

    const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
    const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
    const onResetFilter = useCallback(() => setState(() => standardFilter), [setState]);

    const isFilterChanged = isFilterActive<PersistentFilter>(currentState, standardFilter, ignoreKeys);

    useEffect(() =>
    {
        if (filter?.isFilterActive !== isFilterChanged) {
            onFilterActive && onFilterActive(isFilterChanged);
        }
    }, [isFilterChanged, filter, onFilterActive]);

    return <>
        <FilterList
            isOpen={filter?.isFilterOpen || false}
            isDetailsOpen={filter?.isDetailOpen || false}
            onIsOpen={onIsFilterOpen}
            onDetailOpen={onIsDetailFilterOpen}
            onReset={onResetFilter}
            noPrint
            details={<>
                <IonCol>
                    {/*    <TypeaheadString
                        id="output"
                        reset={clearFilterInputs}
                        onFilter={async (value: string) =>
                        {
                            setState({ ...currentState, output: (a: string, b: string): boolean => stringFilter(a, value) });
                            const list = await getList(data, 'output');
                            return list;
                        }}
                        disabled={!data.length}
                        text={"[SID_MNU_OUTPUTS]"}
                    />
 */}
                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
            </>}
        >
        </FilterList >



        <List
            rows={list}
            maxHeight={mobileView ? '86vh' : "58vh"}
            headers={header}

        />
    </>;
};

export default OtherAlarmDevices;

